import { render, staticRenderFns } from "./PeerGroup.vue?vue&type=template&id=2a60aca5&scoped=true"
import script from "./PeerGroup.vue?vue&type=script&lang=js"
export * from "./PeerGroup.vue?vue&type=script&lang=js"
import style0 from "./PeerGroup.vue?vue&type=style&index=0&id=2a60aca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60aca5",
  null
  
)

export default component.exports